// extracted by css-extract-rspack-plugin
export default {"token":"AgentTasksToken-module__token__kMHqG","tokenCaret":"AgentTasksToken-module__tokenCaret__YAF4S"};